export default {
  banner_text:
    "Nous utilisons des cookies pour faire fonctionner l’application (essentiels) et l’améliorer (analytiques). Choisissez ce que vous autorisez.",
  essential_required: "Essentiels (obligatoire)",
  analytics: "Analytiques",
  marketing: "Marketing",
  allow_essential_only: "Autoriser uniquement l’essentiel",
  save_choices: "Enregistrer mes choix",
  accept_all: "Tout accepter",
  aria_label: "Consentement aux cookies"
};
